export class Login {
  showLocationOnForm: boolean;
  logLogins?: boolean;
  existingCustomersText?: string;
  forgotPasswordText?: string;

  constructor() {
    this.showLocationOnForm = true;
    this.existingCustomersText = 'Existing Customers';
    this.forgotPasswordText = 'Recover your Password';
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/login.ts